import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import foodImg from "../../assets/mdi_food.png";
import scooterImg from "../../assets/scooter.png";
import dineIn from "../../assets/dinein.png";
import takeWay from "../../assets/takeway.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LanguageMenuItem from "../../components/SelectComponent/LanguageMenuItem";
import {
  resetWebshop,
  setLanguageData,
  updateDefaultLanguage,
  updateDeliveryType,
} from "../../store/slice/Webshop.slice";
import { send } from "../../utils/utils";

export const RibbonTag = ({ data }) => {
  return (
<Box
  sx={{
    position: "absolute",
    top: "40%",
    border:"3px solid red",
    width: { xs: "80%", sm: "220px" },
    // right: "-40px",
   transform: "rotate(-15deg)",
   // width: "280px",
  //  height:"280px",
    //backgroundColor: "rgba(244, 67, 54, 0.30)", // another soft red
    color: "red", // white text
    textAlign: "center",
    fontWeight: 700,
   // fontSize: "13px",
    padding: "6px 0",
    borderRadius: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    pointerEvents: "none",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
    
    display:"flex",
    justifyContent:"center",
    alignItems:"center"
    
  }}
>
  <Typography sx={{fontWeight:"800",fontSize:"1.3rem"}}>
  {data}
  </Typography>
 
</Box>

  );
};

const DeliveryTypeScreen = () => {
  const [startHere, setStartHere] = useState(true);
  const dispatch = useDispatch();
  const [deliveryType, setDelvieryType] = useState("");
  const navigate = useNavigate();
  const { languageData, defaultLanguage,shopType,webshopSettings,webshopLoading,languageWords,webShopMenuPosition,langID,webshopOpeningHours} = useSelector(
    (store) => store?.Webshop
  );

  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  
  const deliveryCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "DeliveryTypeScreen"
  )?.fields

  const contentRef = React.useRef(null);
  const sendHeight = React.useCallback(() => {
    if (!contentRef.current) return;
  
    const height = contentRef.current.scrollHeight + 120;
  
    send(`${height}px`, "100%", "", "0px", "0px", "", "relative");
  }, []);
  
  React.useLayoutEffect(() => {
    if (!contentRef.current) return;
    sendHeight();
  }, []);

  return (
    <>
      {languageData?.length > 1 && <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          height:"auto"
        }}
      >
        <LanguageMenuItem
          languageData={languageData}
          updateLanguageData={setLanguageData}
          defaultLanguage={defaultLanguage}
          updateDefaultLanguage={updateDefaultLanguage}
        />
      </Box>}
      <Box
      ref={contentRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        
        }}
      >
        {/* Main Content */}
        <Box>
          {/* Header Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              px: 2,
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                color:deliveryCss?.deliveryHeadingClr,
                fontSize: { xs: "24px", md: "40px" },
                fontWeight: 600,
                mb: 1,
              }}
            >
              {webshopSettings?.webshopWidgetSetupLanguages?.find((item)=>item?.fieldname == 'PickupOrDeliveryScreenHeading' && item?.idlanguage == langID)?.data}
            </Typography>
            <Typography
              sx={{
                width: { md: 650, xs: "100%" },
                textAlign: "center",
                fontSize: "16px",
                color: deliveryCss?.deliveryInfoClr,
                lineHeight: "1.5rem",
              }}
            >
               {webshopSettings?.webshopWidgetSetupLanguages?.find((item)=>item?.fieldname == 'PickupOrDeliveryScreenInfo' && item?.idlanguage == langID)?.data}
            </Typography>
          </Box>
          {/* webshop  */}
          
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: { xs: "1.5rem", md: "3rem" },
                width: "100%",
                mt: 7,
                pb: 6, // Add padding to avoid overlap with footer
              }}
            >
              {/* Pickup Card */}
              {webshopSettings?.hasPickup && webshopSettings?.showPickupWebshopWidget && <Box
                sx={{
                  width: { xs: "80%", sm: "240px" },
              height: "280px",
              backgroundColor:
                deliveryType === "pickup"  ? "#F37120" : deliveryCss?.deliveryCardBgClr,
              borderRadius: "20px",
              boxShadow:
                deliveryType === "pickup" 
                  ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                  : "0 4px 12px rgba(0,0,0,0.1)",
              transition: "all 0.3s ease",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
           
              position: "relative",
              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow:
                  "0 10px 25px rgba(243, 113, 32, 0.35)",
                backgroundColor:deliveryCss?.deliveryCardHoverClr
              },
                }}
                onClick={() => {   
                     dispatch(updateDeliveryType("pickup"));      
                  navigate(`/webshopMenuItem`);
                  
                }}
              >
                <Box
                  sx={{
                    backgroundColor: deliveryCss?.
                    deliveryCardImgBgClr,
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                    opacity:!webshopOpeningHours?.value?.data?.companyOpen ? 0.25 : 1
                    
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={foodImg}
                    alt="food-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "pickup" ? "#fff" : deliveryCss?.deliveryCardTitleClr                    ,
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                  {languageWords.Pickup}
                </Typography>
              {!webshopOpeningHours?.value?.data?.companyOpen && <RibbonTag  data={"We are Closed"}/>}
              </Box>}

                  {/* Dine In */}
                  {webshopSettings?.hasDineIn &&  webshopSettings?.showDineInWebshopWidget &&   <Box
                sx={{
                  width: { xs: "80%", sm: "240px" },
                  height: "280px",
                  backgroundColor:
                    deliveryType === "DineIn"  ? "#F37120" :deliveryCss?.deliveryCardBgClr,
                  borderRadius: "20px",
                  boxShadow:
                    deliveryType === "DineIn" 
                      ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  position: "relative",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow:
                      "0 10px 25px rgba(243, 113, 32, 0.35)",
                      backgroundColor:deliveryCss?.deliveryCardHoverClr
                  },
                }}
                onClick={() => {
                  dispatch(updateDeliveryType("DineIn"));
                  navigate(`/webshopMenuItem`);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: deliveryCss?.
                    deliveryCardImgBgClr,
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                    opacity:!webshopOpeningHours?.value?.data?.companyOpen ? 0.25 : 1
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={dineIn}
                    alt="dine-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "DineIn" ? "#fff" :deliveryCss?.deliveryCardTitleClr,
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                     {languageWords.DineIn}
                </Typography>
                {!webshopOpeningHours?.value?.data?.companyOpen && <RibbonTag  data={"we are closed"}/>}
              </Box>}
                  {/* Delivery Card */}
                  {webshopSettings?.hasDelivery && webshopSettings?.showDeliveryWebshopWidget &&  webshopOpeningHours?.value?.data?.delivery && <Box
                sx={{
                  width: { xs: "80%", sm: "240px" },
                  height: "280px",
                  backgroundColor:
                    deliveryType === "delivery"  ? "#F37120" :deliveryCss?.deliveryCardBgClr,
                  borderRadius: "20px",
                  boxShadow:
                    deliveryType === "delivery" 
                      ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  position: "relative",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow:
                      "0 10px 25px rgba(243, 113, 32, 0.35)",
                      backgroundColor:deliveryCss?.deliveryCardHoverClr
                  },
                }}
                onClick={() => {
                  dispatch(updateDeliveryType("delivery"));
                  navigate(`/webshopMenuItem`);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: deliveryCss?.
                    deliveryCardImgBgClr,
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={scooterImg}
                    alt="scooter-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "delivery" ? "#fff" : deliveryCss?.deliveryCardTitleClr,
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                     {languageWords.Delivery}
                </Typography>
              </Box>}
            </Box>
          
        </Box>
      </Box>
    </>
  );
};

export default DeliveryTypeScreen;
